
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13610",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13610",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1327",
  "client-types": "static-1.523",
  "data-fetching-client": "static-1.10172",
  "foundations-components": "static-1.8848",
  "foundations-components-legacy": "static-1.1873",
  "foundations-theming": "static-1.5038",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.96",
  "head-dlb": "static-1.5344",
  "hs-test-utils": "static-1.8579",
  "hub-http-shared-msw-handlers": "static-1.11003",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.12025",
  "I18n": "static-7.1724",
  "jasmine-runner": "static-1.6995",
  "marketplace-discovery-studio-lib": "static-1.1002",
  "marketplace-storefront-base": "static-1.13673",
  "quartz": "static-1.7755",
  "react-dlb": "static-1.97",
  "react-rhumb": "static-1.17274",
  "reactive-variable-buffer-atom": "static-1.3386",
  "reporting-testing-lib": "static-1.11564",
  "reselect": "static-3.20",
  "settings-ui-lib": "static-1.13069",
  "SharedI18nStrings": "static-1.191",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7937",
  "ui-addon-i18n": "static-1.11684",
  "ui-addon-react-router-dom": "static-1.10065",
  "unified-auth": "static-1.1371",
  "unified-auth-core-lib": "static-1.1653",
  "usage-tracker": "static-1.7879",
  "usage-tracker-core": "static-1.7729",
  "customer-data-property-utils": "static-1.8596",
  "hub-http": "static-1.6742",
  "integrations-lib": "static-1.17559",
  "marketplace-ui-common": "static-1.21153",
  "marketplace-ui-install": "static-1.1139",
  "property-management-iframe": "static-1.14609",
  "quartz-config": "static-1.1533",
  "quartz-core": "static-1.6974",
  "quartz-routing": "static-1.1185",
  "quick-fetch": "static-1.4266",
  "react": "static-7.206",
  "rpc-client-utils": "static-1.5203",
  "ts-schema": "static-1.4432",
  "ui-universal-auth": "static-1.9857",
  "UIComponents": "static-3.8971",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.529",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven": "static-3.6435",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.4032",
  "quartz-webpack": "static-1.3979",
  "bend-plugin-quartz-routing": "static-1.833",
  "ai-components-ui-library": "static-1.10126",
  "codemirror": "static-5.109",
  "foundations-assets": "static-1.5426",
  "pulse": "static-1.1203",
  "react-codemirror": "static-1.11179",
  "ui-extensions-preview-lib": "static-1.1104",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5117",
  "floating-ui": "static-1.71",
  "foundations-theming-specialty": "static-1.2754",
  "framer-motion": "static-1.87",
  "hs-story-utils": "static-1.9961",
  "react-aria": "static-1.80",
  "react-create-root-preference": "static-1.121",
  "react-select-plus": "static-1.121",
  "react-utils": "static-2.5716",
  "react-virtualized": "static-2.115",
  "StyleGuideUI": "static-3.521",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3255",
  "ui-fonts": "static-1.1287",
  "ui-images": "static-2.1295",
  "bend-plugin-foundations-theming": "static-1.3521",
  "foundations-theming-base": "static-1.4023",
  "stylex": "static-1.49",
  "HeadJS": "static-2.837",
  "hs-test-utils-bend-plugin": "static-1.3690",
  "msw": "static-1.106",
  "msw-config": "static-1.43",
  "testing-library": "static-1.168",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4842",
  "ui-addon-video-player": "static-1.9159",
  "ai-rendering-library": "static-1.11543",
  "chirp-fetch": "static-1.2437",
  "connections-embed-lib": "static-1.1846",
  "copilot-toolkit": "static-1.12263",
  "feedback-loader": "static-1.30147",
  "laboratory-lib": "static-3.7685",
  "marketplace-embed": "static-1.23306",
  "marketplace-ui-details": "static-1.11048",
  "marketplace-ui-reviews": "static-1.21108",
  "marketplace-ui-tracking": "static-1.15323",
  "sanitize-text": "static-1.8694",
  "usage-tracker-multi": "static-1.6293",
  "usage-tracker-session-replay": "static-1.5565",
  "beacon-keepalive-queue": "static-1.239",
  "quartz-head": "static-1.1420",
  "web-vitals": "static-1.22",
  "apollo-link-hub-http": "static-2.5126",
  "immer": "static-1.107",
  "immerable": "static-1.4681",
  "highcharts": "static-8.118",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2899",
  "reporting-data": "static-1.69631",
  "cssUtils": "static-1.1160",
  "flux-actions": "static-1.384",
  "react-colorpicker": "static-2.10746",
  "react-dnd-compat": "static-1.5147",
  "redux-observable": "static-1.82",
  "ReduxMessenger": "static-2.10909",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7869",
  "icons": "static-2.715",
  "marketplace-ui-apps-core": "static-1.19685",
  "storybook-react": "static-1.47",
  "trellis-story-utils": "static-1.5033",
  "foundations-components-test-utils": "static-1.6331",
  "quartz-i18n": "static-1.1430",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.844",
  "ads-unified-auth-lib": "static-1.2310",
  "ai-mcp-auth-lib": "static-1.84",
  "cohere-settings-lib": "static-1.10544",
  "custom-vendor-connection-lib": "static-1.421",
  "gemini-settings-lib": "static-1.9894",
  "google-sheets-integration-lib": "static-1.1442",
  "microsoft-drive-auth-lib": "static-1.640",
  "slack-ui-library": "static-1.10939",
  "surveymonkey-integration-lib": "static-1.955",
  "x-ai-settings-lib": "static-1.10602",
  "fsm": "static-1.4298",
  "customer-data-objects": "static-1.8251",
  "property-translator": "static-1.5913",
  "hs-locale-management": "static-1.441",
  "frontend-preferences-client": "static-1.8460",
  "hs-promise-utils": "static-1.6127",
  "hubspot-apollo-client": "static-1.5413",
  "integrations-error-boundary-lib": "static-1.14974",
  "integrations-tracking-lib": "static-1.6165",
  "native-integrations-shared-strings": "static-1.8295",
  "sanitize": "static-1.5005",
  "superstore": "static-1.5292",
  "ui-shepherd-react": "static-3.10824",
  "ai-settings-ui-library": "static-1.8685",
  "hub-http-janus": "static-1.920",
  "hubspotter-http": "static-1.5012",
  "immutable-less": "static-1.5185",
  "marketplace-ui-client-types": "static-1.18560",
  "nav-meta": "static-1.30957",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18608",
  "ui-product-approvals-common": "static-1.1806",
  "ai-studio-lib": "static-1.12909",
  "hubspot-prosemirror": "static-1.19398",
  "integrations-reconnect-lib": "static-1.819",
  "ui-addon-iframeable": "static-1.9617",
  "ui-addon-integrations-directory-panel": "static-2.8486",
  "ui-product-approvals": "static-1.29910",
  "ui-tool-access": "static-1.10691",
  "data-agent-kit": "static-1.1047",
  "inbound-db-properties-service-client": "static-1.4189",
  "property-management-common": "static-1.6897",
  "smart-property-fill-lib": "static-1.866",
  "opentelemetry-fe-types": "static-1.337",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "hs-browser-apis": "static-1.17",
  "mobile-manifest-mixins": "static-1.619",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.712",
  "quartz-auth": "static-1.1430",
  "quartz-test": "static-1.1430",
  "quartz-tracking": "static-1.1134",
  "trellis-components": "static-1.3274",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.613",
  "HubStyle": "static-2.12332",
  "bender-build-tools": "static-1.3648",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24268",
  "ContentUtils": "static-1.69616",
  "customer-data-objects-ui-components": "static-1.13573",
  "sassPrefix": "static-1.424",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2087",
  "bend-plugin-pulse": "static-1.706",
  "event-emitter": "static-1.1497",
  "fast-json-patch": "static-1.77",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5960",
  "magpie-types": "static-1.5420",
  "stylex-utils": "static-1.191",
  "trellis-theming": "static-1.1580",
  "avatar-components": "static-1.3025",
  "breeze-engine-core": "static-1.1662",
  "breeze-engine-lib": "static-1.2384",
  "breeze-onboarding-components": "static-1.1212",
  "breeze-upgrade-component-lib": "static-1.52",
  "customer-data-filters-ui": "static-1.41543",
  "customer-data-reference-ui-components": "static-1.13713",
  "data-integrations-breeze": "static-1.540",
  "embedded-academy-lib": "static-1.16195",
  "ExportDialog": "static-6.10911",
  "global-styles-ai-lib": "static-1.607",
  "highlight.js": "static-1.93",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.1009",
  "mermaid": "static-1.48",
  "reporting-action-components": "static-1.42525",
  "reporting-snowflake": "static-1.58247",
  "reporting-ui-components": "static-2.66900",
  "reporting-visualizations": "static-1.61705",
  "trial-components-library": "static-1.14480",
  "ui-addon-teams": "static-1.22076",
  "upgrade-components-lib": "static-1.795",
  "navigation-components": "static-1.19320",
  "nest": "static-1.775",
  "simple-logging-lib": "static-1.3584",
  "nudge-client-utils": "static-1.3509",
  "fail-safe": "static-1.483",
  "app-governance-lib": "static-1.2841",
  "developer-experience-shared-components": "static-1.11082",
  "purchase-motions-components": "static-1.6720",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10967",
  "usage-tracker-anonymous": "static-1.6296",
  "usage-tracker-public": "static-1.7690",
  "amplitude-session-replay-browser": "static-1.80",
  "inbound-db-meta-service-client": "static-1.3809",
  "persist-promise": "static-1.4244",
  "reference-resolvers": "static-1.8723",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4455",
  "hubspot-apollo-cache": "static-1.872",
  "universal-page-editor-lib": "static-1.3557",
  "final-form": "static-1.86",
  "redux-toolkit": "static-1.85",
  "simple-data-table": "static-1.3936",
  "merchandise-lib": "static-1.289",
  "onboarding-scopes": "static-1.6989",
  "permissions-summary-ui-lib": "static-1.131",
  "ui-addon-draggable": "static-3.5289",
  "content-assistance-lib": "static-1.8503",
  "content-media-capture": "static-1.5884",
  "customer-data-ui-utilities": "static-1.10370",
  "emoji-mart": "static-3.10",
  "file-manager-components": "static-1.24932",
  "growth-payments-core": "static-1.26624",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3413",
  "payment-link-components": "static-1.24582",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20643",
  "ui-addon-emoji-picker": "static-1.10401",
  "ui-business-units-lib": "static-1.9633",
  "video-components-external": "static-1.12547",
  "video-data-lib": "static-1.36205",
  "navigation-messaging": "static-1.8647",
  "collaboration-sidebar": "static-1.59169",
  "trellis-ext-dnd": "static-1.634",
  "policy-lib": "static-1.7341",
  "crm-component-utils": "static-1.40335",
  "crm-properties-common-lib": "static-1.6434",
  "customer-data-properties": "static-1.53248",
  "external-options-client-types": "static-1.4477",
  "hs-resources": "static-1.733",
  "property-value-citations": "static-1.3862",
  "reference-resolvers-lite": "static-1.8650",
  "access-check-ui-lib": "static-1.2029",
  "crm-message-bus": "static-1.44257",
  "data-agent-test-utils": "static-1.591",
  "data-agent-usage-based-billing": "static-1.234",
  "data-agent-utils": "static-1.1060",
  "enrichment-settings-lib": "static-1.405",
  "smart-property-lib": "static-1.8848",
  "opentelemetry-web": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.11001",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.18",
  "tanstack-virtual": "static-1.46",
  "cms-field-types": "static-1.5350",
  "content-icons-ui": "static-1.2521",
  "atom": "static-1.5610",
  "idb-keyval": "static-1.58",
  "reactive-lib": "static-1.1259",
  "trellis-migration-context": "static-1.115",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1362",
  "breeze-artifacts-sdk": "static-1.1201",
  "breeze-assistant-components": "static-1.2756",
  "getting-started-shared-tasks": "static-1.19657",
  "onboarding-journeys-lib": "static-1.1352",
  "interactive-cards": "static-1.618",
  "conversations-skeleton-state": "static-1.7650",
  "customer-data-filters-ui-msw-helpers": "static-1.23978",
  "events-data-lib": "static-1.790",
  "FormUrlGenerator": "static-2.5251",
  "framework-builder-read-service-client": "static-1.4373",
  "multi-account-reference-resolvers": "static-1.1558",
  "onboarding-tours": "static-1.17480",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14870",
  "segments-client-types": "static-1.12380",
  "academy-common-lib": "static-1.15656",
  "dashboard-lib": "static-1.83462",
  "hubspot-prosemirror-plugins": "static-1.19390",
  "reporting-plugins": "static-1.11101",
  "share-with-third-party-component-lib": "static-1.9251",
  "ui-addon-draggable-compat": "static-2.4798",
  "ui-asset-management-lib": "static-1.11646",
  "user-context": "static-1.5595",
  "reporting-reports": "static-1.69307",
  "hubs-service-types": "static-1.1803",
  "purchase-motions-api": "static-1.6723",
  "salesImages": "static-1.795",
  "signup-constants": "static-1.20112",
  "nudge-custom-function-registry": "static-1.3266",
  "nudge-renderer-utils": "static-1.3585",
  "whisper-core-api": "static-1.7735",
  "bend-plugin-fail-safe": "static-1.434",
  "framework-listing-lib": "static-2.29940",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31873",
  "apps-service-types": "static-1.4145",
  "oauth-service-types": "static-1.4673",
  "signup-ui-url-generator": "static-2.8572",
  "onboarding-tours-client": "static-1.5695",
  "one-click-checkout": "static-1.871",
  "platform-infra-nav-components": "static-1.8038",
  "purchasing-components-lib": "static-1.1121",
  "subscription-experience-data-types": "static-1.15519",
  "crm-record-cards-client": "static-1.225",
  "crm-record-cards-service-types": "static-1.3894",
  "framework-data-schema-resolvers": "static-1.7431",
  "location-customization-utils-lib": "static-1.10554",
  "redux-thunk": "static-2.88",
  "seat-types-lib": "static-1.1167",
  "react-flip-move": "static-1.86",
  "ui-coaching-tips": "static-1.29640",
  "content-media-composition-data-lib": "static-1.13688",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4966",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.4013",
  "ui-addon-opt": "static-4.8971",
  "commerce-tours-lib": "static-1.6948",
  "growth-onboarding-reliability": "static-1.5620",
  "sales-checkout-service-client": "static-1.4059",
  "data-token-picker": "static-1.17222",
  "FileManagerLib": "static-1.40572",
  "content-media-compositions": "static-2.17695",
  "media-bridge-lib": "static-1.19728",
  "chatspot-widget-iframe": "static-1.24259",
  "collaboration-sidebar-common": "static-1.3966",
  "marketing-platform-lib": "static-1.7448",
  "dnd-kit": "static-1.24",
  "commerce-subscription-lib": "static-1.38166",
  "crm-actions": "static-1.6949",
  "crm-cards-sdk": "static-1.45196",
  "customer-data-properties-shared-msw-handlers": "static-1.10330",
  "customer-data-tracking": "static-1.7408",
  "calling-global-api": "static-1.66505",
  "calling-internal-common": "static-1.31860",
  "calling-lifecycle-internal": "static-1.67887",
  "calling-lifecycle-messages": "static-1.60179",
  "commerce-products-lib": "static-1.11090",
  "conditional-properties-service-client": "static-1.4149",
  "crm-index-visualization-core": "static-1.4849",
  "crm-links": "static-1.6864",
  "crm-pipelines-api-client-types": "static-1.4483",
  "formula-editor": "static-1.15082",
  "google-libphonenumber": "static-1.53",
  "inbounddb-objects-service-types": "static-1.4553",
  "meetings-icalendar-utils-lib": "static-1.1172",
  "multi-currency-client-types": "static-1.4048",
  "object-builder-ui-client": "static-1.50212",
  "pipeline-validation-client-types": "static-1.4321",
  "react-tinymce": "static-1.56371",
  "smart-data-capture-core": "static-1.609",
  "tiered-pricing": "static-1.2386",
  "tinymce-config": "static-2.55497",
  "tinymce-plugins": "static-1.58611",
  "tinymce-themes": "static-1.57467",
  "topics-actions-lib": "static-1.730",
  "trellis-ext-i18n": "static-1.1478",
  "ui-addon-form-validation": "static-1.11353",
  "zustand": "static-1.93",
  "fdsr-migration-layer": "static-1.550",
  "permissions-shared-i18n-strings-fe": "static-1.2146",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11086",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11149",
  "sales-views-client-types": "static-1.4795",
  "breeze-sharing-core": "static-1.98",
  "dompurify": "static-1.17",
  "utility-belt": "static-1.3072",
  "growth-data-modal": "static-1.6215",
  "growth-onboarding-confetti": "static-1.3593",
  "growth-onboarding-next-action-utils": "static-1.3096",
  "onboarding-tours-utils": "static-1.1547",
  "ui-shepherd-tracker": "static-1.8205",
  "crm-index-associations-lib": "static-1.6987",
  "academy-service-client": "static-1.4230",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40431",
  "SafeStorage": "static-1.4932",
  "video-embed": "static-1.37039",
  "redux-actions": "static-3.77",
  "EmailSignatureEditor": "static-1.25346",
  "viral-links-lib": "static-1.7619",
  "campaign-roi-lib": "static-1.11016",
  "campaigns-utils-lib": "static-1.3807",
  "ui-addon-calendars": "static-2.5909",
  "nested-table": "static-1.759",
  "timezone-utils": "static-2.5763",
  "getting-started-shared-tasks-store": "static-1.18775",
  "customer-data-views-management": "static-1.26459",
  "framework-data-table": "static-2.12943",
  "nudge-custom-ui-functions": "static-1.1820",
  "switchboard-lib": "static-1.783",
  "app-users-service-client": "static-1.6157",
  "app-users-service-types": "static-1.5565",
  "mini-checkout-client": "static-1.27966",
  "onboarding-utils": "static-1.5912",
  "ui-coaching-tips-shared-config": "static-1.29625",
  "checkout-sdk": "static-3.24809",
  "payment-method-components": "static-1.7377",
  "touchless-buying-components": "static-1.6677",
  "upgrade-catalog-service-types": "static-1.3908",
  "pricing-pages-ui-components": "static-1.16817",
  "edison-service-client-types": "static-1.928",
  "framework-data-schema-quick-fetch": "static-1.7336",
  "growth-onboarding-feedback-components": "static-1.7122",
  "audio-components": "static-1.6650",
  "FileManagerImages": "static-1.38083",
  "video-components": "static-1.14549",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20613",
  "commerce-shared-components-lib": "static-1.19691",
  "commerce-tools-ui-lib": "static-1.11431",
  "crm_data": "static-4.93352",
  "crm-activity-creator-data": "static-1.47907",
  "crm-fe-perf": "static-1.23439",
  "universal-record-utils-lib": "static-1.2497",
  "calling-error-reporting": "static-1.31867",
  "shared-worker-versioning": "static-1.11577",
  "calling-usage-tracker": "static-1.7078",
  "voice-sms-access-library": "static-1.2607",
  "commerce-permissions": "static-1.1320",
  "products-iframe-lib": "static-1.9055",
  "products-ui-components-shared-msw-handlers": "static-1.11385",
  "bark-lib": "static-1.17071",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3567",
  "interframe": "static-3.5282",
  "tinymce-data": "static-1.41582",
  "ui-addon-sales-email": "static-1.5744",
  "layout-dnd-components": "static-1.13317",
  "layout-dnd-utils": "static-1.12292",
  "ui-brand-identity-lib": "static-1.17095",
  "NamespacedHubStyle": "static-2.9406",
  "onboarding-data-sync-lib": "static-1.2921",
  "growth-onboarding-next-action-components": "static-1.3124",
  "user-context-client": "static-1.5044",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.68",
  "urlinator": "static-1.5054",
  "outpost": "static-1.4662",
  "draft-convert": "static-2.88",
  "draft-extend": "static-3.91",
  "draft-js": "static-5.93",
  "draft-plugins": "static-2.22448",
  "sales-email-signature-service-client": "static-1.4383",
  "copilot-messaging": "static-1.2513",
  "ts-utils-lib": "static-1.691",
  "crm-export-dialog": "static-1.6816",
  "crm-index-ui-shimmer": "static-1.3127",
  "crm-view-components": "static-1.1647",
  "react-beautiful-dnd": "static-1.78",
  "customer-data-associations": "static-1.7881",
  "tasks-actions-lib": "static-1.558",
  "InboxConnectUtils": "static-4.15953",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.895",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4528",
  "company-details-components": "static-1.6746",
  "react-performance-metrics-lib": "static-1.1088",
  "quote-checkout-service-types": "static-1.3997",
  "pricing-pages-api": "static-1.16683",
  "social-insights-client-types": "static-1.23041",
  "crm-command-handler-types": "static-1.195",
  "payments-enrollment-embed-lib": "static-1.24398",
  "stripe-embedded-components": "static-1.8333",
  "customer-data-rte": "static-1.33998",
  "cv-backend-services": "static-1.1621",
  "growth-onboarding-empty-states": "static-1.6626",
  "payments-post-enroll-local-storage-lib": "static-1.5637",
  "qrcode-generator": "static-1.83",
  "quotes-client-types": "static-1.39284",
  "crm_universal": "static-1.22809",
  "customer-data-email": "static-1.18734",
  "meetings-rte-lib": "static-1.634",
  "universal-associations-select": "static-1.11642",
  "crm-object-search-query-utilities": "static-1.10564",
  "calling-orchestration-schema": "static-1.37384",
  "react-reducer-toolkit": "static-1.16769",
  "ContentData": "static-1.69691",
  "layout-data-lib": "static-1.10617",
  "meetings-connect-utils-lib": "static-1.8156",
  "company-details-service-types": "static-1.4477",
  "segments-query-core": "static-1.1964",
  "stripe-connect-js": "static-1.86",
  "draft-content-plugins": "static-1.29251",
  "sequences-lib": "static-1.8870",
  "ui-gdpr-components": "static-1.10659",
  "meetings-client-types": "static-1.4125",
  "meetings-core": "static-1.856",
  "advanced-menus-core": "static-1.15908",
  "advanced-menus-lib": "static-1.12638",
  "ui-memberships-settings-lib": "static-1.35326",
  "sequences-client-types-lib": "static-1.8727",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15907",
  "simple-menus-lib": "static-1.17424"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13610",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1327",
  "client-types": "/client-types/static-1.523",
  "data-fetching-client": "/data-fetching-client/static-1.10172",
  "foundations-components": "/foundations-components/static-1.8848",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1873",
  "foundations-theming": "/foundations-theming/static-1.5038",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.96",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-test-utils": "/hs-test-utils/static-1.8579",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11003",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.12025",
  "I18n": "/I18n/static-7.1724",
  "jasmine-runner": "/jasmine-runner/static-1.6995",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.1002",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13673",
  "quartz": "/quartz/static-1.7755",
  "react-dlb": "/react-dlb/static-1.97",
  "react-rhumb": "/react-rhumb/static-1.17274",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3386",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11564",
  "reselect": "/reselect/static-3.20",
  "settings-ui-lib": "/settings-ui-lib/static-1.13069",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7937",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11684",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10065",
  "unified-auth": "/unified-auth/static-1.1371",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1653",
  "usage-tracker": "/usage-tracker/static-1.7879",
  "usage-tracker-core": "/usage-tracker-core/static-1.7729",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8596",
  "hub-http": "/hub-http/static-1.6742",
  "integrations-lib": "/integrations-lib/static-1.17559",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21153",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1139",
  "property-management-iframe": "/property-management-iframe/static-1.14609",
  "quartz-config": "/quartz-config/static-1.1533",
  "quartz-core": "/quartz-core/static-1.6974",
  "quartz-routing": "/quartz-routing/static-1.1185",
  "quick-fetch": "/quick-fetch/static-1.4266",
  "react": "/react/static-7.206",
  "rpc-client-utils": "/rpc-client-utils/static-1.5203",
  "ts-schema": "/ts-schema/static-1.4432",
  "ui-universal-auth": "/ui-universal-auth/static-1.9857",
  "UIComponents": "/UIComponents/static-3.8971",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.529",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven": "/raven/static-3.6435",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4032",
  "quartz-webpack": "/quartz-webpack/static-1.3979",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.833",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10126",
  "codemirror": "/codemirror/static-5.109",
  "foundations-assets": "/foundations-assets/static-1.5426",
  "pulse": "/pulse/static-1.1203",
  "react-codemirror": "/react-codemirror/static-1.11179",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1104",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5117",
  "floating-ui": "/floating-ui/static-1.71",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2754",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-story-utils": "/hs-story-utils/static-1.9961",
  "react-aria": "/react-aria/static-1.80",
  "react-create-root-preference": "/react-create-root-preference/static-1.121",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-utils": "/react-utils/static-2.5716",
  "react-virtualized": "/react-virtualized/static-2.115",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3255",
  "ui-fonts": "/ui-fonts/static-1.1287",
  "ui-images": "/ui-images/static-2.1295",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3521",
  "foundations-theming-base": "/foundations-theming-base/static-1.4023",
  "stylex": "/stylex/static-1.49",
  "HeadJS": "/HeadJS/static-2.837",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3690",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.43",
  "testing-library": "/testing-library/static-1.168",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4842",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9159",
  "ai-rendering-library": "/ai-rendering-library/static-1.11543",
  "chirp-fetch": "/chirp-fetch/static-1.2437",
  "connections-embed-lib": "/connections-embed-lib/static-1.1846",
  "copilot-toolkit": "/copilot-toolkit/static-1.12263",
  "feedback-loader": "/feedback-loader/static-1.30147",
  "laboratory-lib": "/laboratory-lib/static-3.7685",
  "marketplace-embed": "/marketplace-embed/static-1.23306",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.11048",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21108",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15323",
  "sanitize-text": "/sanitize-text/static-1.8694",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6293",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5565",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.239",
  "quartz-head": "/quartz-head/static-1.1420",
  "web-vitals": "/web-vitals/static-1.22",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5126",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4681",
  "highcharts": "/highcharts/static-8.118",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2899",
  "reporting-data": "/reporting-data/static-1.69631",
  "cssUtils": "/cssUtils/static-1.1160",
  "flux-actions": "/flux-actions/static-1.384",
  "react-colorpicker": "/react-colorpicker/static-2.10746",
  "react-dnd-compat": "/react-dnd-compat/static-1.5147",
  "redux-observable": "/redux-observable/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10909",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7869",
  "icons": "/icons/static-2.715",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19685",
  "storybook-react": "/storybook-react/static-1.47",
  "trellis-story-utils": "/trellis-story-utils/static-1.5033",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6331",
  "quartz-i18n": "/quartz-i18n/static-1.1430",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.844",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2310",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.84",
  "cohere-settings-lib": "/cohere-settings-lib/static-1.10544",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.421",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9894",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1442",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.640",
  "slack-ui-library": "/slack-ui-library/static-1.10939",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.955",
  "x-ai-settings-lib": "/x-ai-settings-lib/static-1.10602",
  "fsm": "/fsm/static-1.4298",
  "customer-data-objects": "/customer-data-objects/static-1.8251",
  "property-translator": "/property-translator/static-1.5913",
  "hs-locale-management": "/hs-locale-management/static-1.441",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8460",
  "hs-promise-utils": "/hs-promise-utils/static-1.6127",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5413",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14974",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6165",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8295",
  "sanitize": "/sanitize/static-1.5005",
  "superstore": "/superstore/static-1.5292",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10824",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8685",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hubspotter-http": "/hubspotter-http/static-1.5012",
  "immutable-less": "/immutable-less/static-1.5185",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18560",
  "nav-meta": "/nav-meta/static-1.30957",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18608",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1806",
  "ai-studio-lib": "/ai-studio-lib/static-1.12909",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19398",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.819",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9617",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8486",
  "ui-product-approvals": "/ui-product-approvals/static-1.29910",
  "ui-tool-access": "/ui-tool-access/static-1.10691",
  "data-agent-kit": "/data-agent-kit/static-1.1047",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4189",
  "property-management-common": "/property-management-common/static-1.6897",
  "smart-property-fill-lib": "/smart-property-fill-lib/static-1.866",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.337",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "hs-browser-apis": "/hs-browser-apis/static-1.17",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.619",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.712",
  "quartz-auth": "/quartz-auth/static-1.1430",
  "quartz-test": "/quartz-test/static-1.1430",
  "quartz-tracking": "/quartz-tracking/static-1.1134",
  "trellis-components": "/trellis-components/static-1.3274",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.613",
  "HubStyle": "/HubStyle/static-2.12332",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24268",
  "ContentUtils": "/ContentUtils/static-1.69616",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13573",
  "sassPrefix": "/sassPrefix/static-1.424",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2087",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.706",
  "event-emitter": "/event-emitter/static-1.1497",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5960",
  "magpie-types": "/magpie-types/static-1.5420",
  "stylex-utils": "/stylex-utils/static-1.191",
  "trellis-theming": "/trellis-theming/static-1.1580",
  "avatar-components": "/avatar-components/static-1.3025",
  "breeze-engine-core": "/breeze-engine-core/static-1.1662",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2384",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1212",
  "breeze-upgrade-component-lib": "/breeze-upgrade-component-lib/static-1.52",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41543",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13713",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.540",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16195",
  "ExportDialog": "/ExportDialog/static-6.10911",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.607",
  "highlight.js": "/highlight.js/static-1.93",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.1009",
  "mermaid": "/mermaid/static-1.48",
  "reporting-action-components": "/reporting-action-components/static-1.42525",
  "reporting-snowflake": "/reporting-snowflake/static-1.58247",
  "reporting-ui-components": "/reporting-ui-components/static-2.66900",
  "reporting-visualizations": "/reporting-visualizations/static-1.61705",
  "trial-components-library": "/trial-components-library/static-1.14480",
  "ui-addon-teams": "/ui-addon-teams/static-1.22076",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.795",
  "navigation-components": "/navigation-components/static-1.19320",
  "nest": "/nest/static-1.775",
  "simple-logging-lib": "/simple-logging-lib/static-1.3584",
  "nudge-client-utils": "/nudge-client-utils/static-1.3509",
  "fail-safe": "/fail-safe/static-1.483",
  "app-governance-lib": "/app-governance-lib/static-1.2841",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11082",
  "purchase-motions-components": "/purchase-motions-components/static-1.6720",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10967",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6296",
  "usage-tracker-public": "/usage-tracker-public/static-1.7690",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3809",
  "persist-promise": "/persist-promise/static-1.4244",
  "reference-resolvers": "/reference-resolvers/static-1.8723",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4455",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.872",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3557",
  "final-form": "/final-form/static-1.86",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "simple-data-table": "/simple-data-table/static-1.3936",
  "merchandise-lib": "/merchandise-lib/static-1.289",
  "onboarding-scopes": "/onboarding-scopes/static-1.6989",
  "permissions-summary-ui-lib": "/permissions-summary-ui-lib/static-1.131",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5289",
  "content-assistance-lib": "/content-assistance-lib/static-1.8503",
  "content-media-capture": "/content-media-capture/static-1.5884",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10370",
  "emoji-mart": "/emoji-mart/static-3.10",
  "file-manager-components": "/file-manager-components/static-1.24932",
  "growth-payments-core": "/growth-payments-core/static-1.26624",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3413",
  "payment-link-components": "/payment-link-components/static-1.24582",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20643",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10401",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9633",
  "video-components-external": "/video-components-external/static-1.12547",
  "video-data-lib": "/video-data-lib/static-1.36205",
  "navigation-messaging": "/navigation-messaging/static-1.8647",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59169",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.634",
  "policy-lib": "/policy-lib/static-1.7341",
  "crm-component-utils": "/crm-component-utils/static-1.40335",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6434",
  "customer-data-properties": "/customer-data-properties/static-1.53248",
  "external-options-client-types": "/external-options-client-types/static-1.4477",
  "hs-resources": "/hs-resources/static-1.733",
  "property-value-citations": "/property-value-citations/static-1.3862",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8650",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.2029",
  "crm-message-bus": "/crm-message-bus/static-1.44257",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.591",
  "data-agent-usage-based-billing": "/data-agent-usage-based-billing/static-1.234",
  "data-agent-utils": "/data-agent-utils/static-1.1060",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.405",
  "smart-property-lib": "/smart-property-lib/static-1.8848",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11001",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.18",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "cms-field-types": "/cms-field-types/static-1.5350",
  "content-icons-ui": "/content-icons-ui/static-1.2521",
  "atom": "/atom/static-1.5610",
  "idb-keyval": "/idb-keyval/static-1.58",
  "reactive-lib": "/reactive-lib/static-1.1259",
  "trellis-migration-context": "/trellis-migration-context/static-1.115",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1362",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1201",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2756",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19657",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1352",
  "interactive-cards": "/interactive-cards/static-1.618",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7650",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23978",
  "events-data-lib": "/events-data-lib/static-1.790",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5251",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4373",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1558",
  "onboarding-tours": "/onboarding-tours/static-1.17480",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14870",
  "segments-client-types": "/segments-client-types/static-1.12380",
  "academy-common-lib": "/academy-common-lib/static-1.15656",
  "dashboard-lib": "/dashboard-lib/static-1.83462",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19390",
  "reporting-plugins": "/reporting-plugins/static-1.11101",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9251",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4798",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11646",
  "user-context": "/user-context/static-1.5595",
  "reporting-reports": "/reporting-reports/static-1.69307",
  "hubs-service-types": "/hubs-service-types/static-1.1803",
  "purchase-motions-api": "/purchase-motions-api/static-1.6723",
  "salesImages": "/salesImages/static-1.795",
  "signup-constants": "/signup-constants/static-1.20112",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3266",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3585",
  "whisper-core-api": "/whisper-core-api/static-1.7735",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.434",
  "framework-listing-lib": "/framework-listing-lib/static-2.29940",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31873",
  "apps-service-types": "/apps-service-types/static-1.4145",
  "oauth-service-types": "/oauth-service-types/static-1.4673",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8572",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5695",
  "one-click-checkout": "/one-click-checkout/static-1.871",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8038",
  "purchasing-components-lib": "/purchasing-components-lib/static-1.1121",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15519",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.225",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3894",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7431",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10554",
  "redux-thunk": "/redux-thunk/static-2.88",
  "seat-types-lib": "/seat-types-lib/static-1.1167",
  "react-flip-move": "/react-flip-move/static-1.86",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29640",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13688",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4966",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.4013",
  "ui-addon-opt": "/ui-addon-opt/static-4.8971",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6948",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5620",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4059",
  "data-token-picker": "/data-token-picker/static-1.17222",
  "FileManagerLib": "/FileManagerLib/static-1.40572",
  "content-media-compositions": "/content-media-compositions/static-2.17695",
  "media-bridge-lib": "/media-bridge-lib/static-1.19728",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24259",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3966",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7448",
  "dnd-kit": "/dnd-kit/static-1.24",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38166",
  "crm-actions": "/crm-actions/static-1.6949",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45196",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10330",
  "customer-data-tracking": "/customer-data-tracking/static-1.7408",
  "calling-global-api": "/calling-global-api/static-1.66505",
  "calling-internal-common": "/calling-internal-common/static-1.31860",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67887",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60179",
  "commerce-products-lib": "/commerce-products-lib/static-1.11090",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4149",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4849",
  "crm-links": "/crm-links/static-1.6864",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4483",
  "formula-editor": "/formula-editor/static-1.15082",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4553",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1172",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4048",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50212",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4321",
  "react-tinymce": "/react-tinymce/static-1.56371",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.609",
  "tiered-pricing": "/tiered-pricing/static-1.2386",
  "tinymce-config": "/tinymce-config/static-2.55497",
  "tinymce-plugins": "/tinymce-plugins/static-1.58611",
  "tinymce-themes": "/tinymce-themes/static-1.57467",
  "topics-actions-lib": "/topics-actions-lib/static-1.730",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1478",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11353",
  "zustand": "/zustand/static-1.93",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.550",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2146",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11086",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11149",
  "sales-views-client-types": "/sales-views-client-types/static-1.4795",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.98",
  "dompurify": "/dompurify/static-1.17",
  "utility-belt": "/utility-belt/static-1.3072",
  "growth-data-modal": "/growth-data-modal/static-1.6215",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3593",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3096",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1547",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8205",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6987",
  "academy-service-client": "/academy-service-client/static-1.4230",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40431",
  "SafeStorage": "/SafeStorage/static-1.4932",
  "video-embed": "/video-embed/static-1.37039",
  "redux-actions": "/redux-actions/static-3.77",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25346",
  "viral-links-lib": "/viral-links-lib/static-1.7619",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.11016",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3807",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5909",
  "nested-table": "/nested-table/static-1.759",
  "timezone-utils": "/timezone-utils/static-2.5763",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18775",
  "customer-data-views-management": "/customer-data-views-management/static-1.26459",
  "framework-data-table": "/framework-data-table/static-2.12943",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1820",
  "switchboard-lib": "/switchboard-lib/static-1.783",
  "app-users-service-client": "/app-users-service-client/static-1.6157",
  "app-users-service-types": "/app-users-service-types/static-1.5565",
  "mini-checkout-client": "/mini-checkout-client/static-1.27966",
  "onboarding-utils": "/onboarding-utils/static-1.5912",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29625",
  "checkout-sdk": "/checkout-sdk/static-3.24809",
  "payment-method-components": "/payment-method-components/static-1.7377",
  "touchless-buying-components": "/touchless-buying-components/static-1.6677",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3908",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16817",
  "edison-service-client-types": "/edison-service-client-types/static-1.928",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7336",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7122",
  "audio-components": "/audio-components/static-1.6650",
  "FileManagerImages": "/FileManagerImages/static-1.38083",
  "video-components": "/video-components/static-1.14549",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20613",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19691",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11431",
  "crm_data": "/crm_data/static-4.93352",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47907",
  "crm-fe-perf": "/crm-fe-perf/static-1.23439",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2497",
  "calling-error-reporting": "/calling-error-reporting/static-1.31867",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11577",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7078",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2607",
  "commerce-permissions": "/commerce-permissions/static-1.1320",
  "products-iframe-lib": "/products-iframe-lib/static-1.9055",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11385",
  "bark-lib": "/bark-lib/static-1.17071",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3567",
  "interframe": "/interframe/static-3.5282",
  "tinymce-data": "/tinymce-data/static-1.41582",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5744",
  "layout-dnd-components": "/layout-dnd-components/static-1.13317",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12292",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17095",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9406",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2921",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3124",
  "user-context-client": "/user-context-client/static-1.5044",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.68",
  "urlinator": "/urlinator/static-1.5054",
  "outpost": "/outpost/static-1.4662",
  "draft-convert": "/draft-convert/static-2.88",
  "draft-extend": "/draft-extend/static-3.91",
  "draft-js": "/draft-js/static-5.93",
  "draft-plugins": "/draft-plugins/static-2.22448",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4383",
  "copilot-messaging": "/copilot-messaging/static-1.2513",
  "ts-utils-lib": "/ts-utils-lib/static-1.691",
  "crm-export-dialog": "/crm-export-dialog/static-1.6816",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3127",
  "crm-view-components": "/crm-view-components/static-1.1647",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.78",
  "customer-data-associations": "/customer-data-associations/static-1.7881",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.558",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15953",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.895",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4528",
  "company-details-components": "/company-details-components/static-1.6746",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1088",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3997",
  "pricing-pages-api": "/pricing-pages-api/static-1.16683",
  "social-insights-client-types": "/social-insights-client-types/static-1.23041",
  "crm-command-handler-types": "/crm-command-handler-types/static-1.195",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24398",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8333",
  "customer-data-rte": "/customer-data-rte/static-1.33998",
  "cv-backend-services": "/cv-backend-services/static-1.1621",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6626",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5637",
  "qrcode-generator": "/qrcode-generator/static-1.83",
  "quotes-client-types": "/quotes-client-types/static-1.39284",
  "crm_universal": "/crm_universal/static-1.22809",
  "customer-data-email": "/customer-data-email/static-1.18734",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.634",
  "universal-associations-select": "/universal-associations-select/static-1.11642",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10564",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37384",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16769",
  "ContentData": "/ContentData/static-1.69691",
  "layout-data-lib": "/layout-data-lib/static-1.10617",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8156",
  "company-details-service-types": "/company-details-service-types/static-1.4477",
  "segments-query-core": "/segments-query-core/static-1.1964",
  "stripe-connect-js": "/stripe-connect-js/static-1.86",
  "draft-content-plugins": "/draft-content-plugins/static-1.29251",
  "sequences-lib": "/sequences-lib/static-1.8870",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10659",
  "meetings-client-types": "/meetings-client-types/static-1.4125",
  "meetings-core": "/meetings-core/static-1.856",
  "advanced-menus-core": "/advanced-menus-core/static-1.15908",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12638",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35326",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8727",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15907",
  "simple-menus-lib": "/simple-menus-lib/static-1.17424"
}
};
